import { action } from '../dispatchAction'
import ActionTypes from './types'

export const add = (
  isPlusUser: boolean,
  onSuccess: () => void = () => {
    return
  }
) => async dispatch => {
  dispatch(action(ActionTypes.add_is_plus_user, isPlusUser))
  onSuccess()
}

export const clear = () => dispatch => {
  dispatch(action(ActionTypes.clear_is_plus_user))
}

export const clearLoaded = () => dispatch => {
  dispatch(action(ActionTypes.clear_loaded))
}



// WEBPACK FOOTER //
// ./src/store/plusUsers/actions.ts